import type { CSSVarFunction } from '@vanilla-extract/private';
import { scaleVars } from '../Common/themes/themeContract.css';

// Added: new types
type RGBType = `rgb(${CSSVarFunction})`;
type RGBAType = `rgba(${CSSVarFunction}, ${number})`;

const rgb = (rgb: CSSVarFunction): RGBType => `rgb(${rgb})`;
const rgba = (rgb: CSSVarFunction, alpha: number): RGBAType => `rgba(${rgb}, ${alpha})`;

// JET-59344 refactor of 'fallbackVar' from '@vanilla-extract/css'.
// directly importing the function was causing vanilla-extract to be bundled into
// the preact packages and causing issues with testing
const fallbackVar = (...values: [string, ...Array<string>]): CSSVarFunction => {
  const finalValue = values.reverse().reduce((acc: string, value: string) => {
    if (acc === '') {
      acc = String(value);
    } else {
      if (typeof value !== 'string' || !/^var\(--.*\)$/.test(value)) {
        throw new Error(`Invalid variable name: ${value}`);
      }

      acc = value.replace(/\)$/, `, ${acc})`);
    }
    return acc;
  }, '');

  return finalValue as CSSVarFunction;
};

// MessageBanner is used by legacy oj-message-banner, so we need to fallback the size units
// var to the legacy CSS var
const xUnits = (cnt: number): string =>
  cnt === 1
    ? fallbackVar(scaleVars.size.units, 'var(--oj-core-spacing-1x)')
    : `calc(${cnt} * ${fallbackVar(scaleVars.size.units, 'var(--oj-core-spacing-1x)')})`;

const min = (val: string, minVal: string): string => `min(${val},${minVal})`;
const max = (val: string, minVal: string): string => `max(${val},${minVal})`;

export { rgb, rgba, xUnits, fallbackVar, min, max };

export type { RGBType, RGBAType };
